import React from 'react';
import './styles/main.scss';

import { HeaderComponent } from './components/header';
import { BodyComponent } from './components/body';
import { FooterComponent } from './components/footer';
import { useInvaderGame } from './hooks/useInvaderGame';

function App() {
  const { score, clicked, handleInvaderClick } = useInvaderGame();

  return (
    <div className='App'>
      <HeaderComponent score={score} />
      <BodyComponent score={score} clicked={clicked} onInvaderClick={handleInvaderClick} />
      <FooterComponent clicked={clicked} onInvaderClick={handleInvaderClick} />
    </div>
  );
}

export default App;
